export default "__VITE_ASSET__nWtTJ5kw__"